// eslint-disable-next-line import/prefer-default-export
export const HTML_LINK_PREFIX = '/htmlPublication/';
